<template>
  <div class="termos">
    <div style="-aw-headerfooter-type: header-primary; clear: both">
      <p class="Header">
        <span
          style="
            height: 0pt;
            display: block;
            position: absolute;
            z-index: -65536;
          "
          ><img
            src="images/Aspose.Words.89c143bb-490c-4446-b8df-1327bde7a713.001.png"
            width="37"
            height="43"
            alt="Uso Interno"
            style="
              margin-top: -0.1pt;
              margin-left: 21.25pt;
              -aw-left-pos: 0pt;
              -aw-rel-hpos: page;
              -aw-rel-vpos: page;
              -aw-top-pos: 0pt;
              -aw-wrap-type: none;
              position: absolute;
            " /></span
        ><span style="-aw-import: ignore">&#xa0;</span>
      </p>
    </div>
    <p
      style="
        margin-bottom: 0pt;
        text-align: center;
        line-height: normal;
        font-size: 15pt;
      "
    >
      <span style="font-weight: bold"
        >SELO SEBRAE DE REFERÊNCIA EM ATENDIMENTO</span
      >
    </p>
    <p
      style="
        margin-bottom: 0pt;
        text-align: center;
        line-height: normal;
        font-size: 15pt;
      "
    >
      <span style="font-weight: bold">Inscrição - Ciclo 2026</span>
    </p>
    <p
      style="
        margin-bottom: 0pt;
        text-align: center;
        line-height: normal;
        font-size: 15pt;
      "
    >
      <span style="font-weight: bold; -aw-import: ignore">&#xa0;</span>
    </p>
    <div class="conteudo">
      <p>
        <span style="font-weight: bold"
          >Agradecemos sua participação no Selo Sebrae de Referência em
          Atendimento!</span
        >
      </p>
      <p style="text-align: justify">
        <span
          >Para participar do ciclo 2026, é obrigatório realizar o preenchimento
          e o envio do formulário de inscrição. Somente após a conclusão dessa
          etapa a instituição parceira será considerada participante do Selo
          Sebrae de Referência em Atendimento no ciclo 2026.</span
        >
      </p>
      <p style="text-align: justify">
        <span>O preenchimento da inscrição tem como objetivos:</span>
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt">
        <li
          class="ListParagraph"
          style="
            margin-left: 27.6pt;
            margin-bottom: 0pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Formalizar a adesão ao Selo e ao processo de análise e validação de
            evidências;</span
          ><span
            style="
              line-height: 108%;

              font-size: 12px;
              -aw-import: spaces;
            "
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;
          </span>
        </li>
        <li
          class="ListParagraph"
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Obter informações que serão utilizadas para a avaliação e apuração
            da pontuação no processo de selagem.</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Conhecer as estruturas e os serviços oferecidos pelas instituições
            parceiras;</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Acompanhar a evolução desses espaços antes e após a aplicação da
            metodologia do Selo Sebrae de Referência em Atendimento;</span
          >
        </li>
      </ul>
      <p style="text-align: justify">
        <span
          >O formulário será disponibilizado por meio de acesso ao sistema do
          Selo, onde os responsáveis pelas instituições parceiras poderão
          preenchê-lo diretamente.</span
        >
      </p>
      <p><span>As perguntas abordam os seguintes aspectos:</span></p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt">
        <li
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Serviços oferecidos;</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Infraestrutura (física e digital);</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Canais de atendimento;</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Equipe de atendimento;</span
          >
        </li>
        <li
          style="
            margin-left: 27.6pt;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Parcerias da instituição.</span
          >
        </li>
      </ul>
      <p><span style="font-weight: bold">PRAZO PARA PREENCHIMENTO:</span></p>
      <p>
        <span>Leia atentamente!</span><br />
        <br /><span>O período de inscrição será de </span
        ><span style="font-weight: bold">10 de março </span><span> a </span
        ><span style="font-weight: bold">30 de abril</span
        ><span> de 2026.</span>
        <br />
        <br /><span>O formulário poderá ser preenchido e enviado até </span
        ><span style="font-weight: bold"
          >30/04/2026, às 17h59 (horário de Brasília).
        </span>
      </p>
      <p>
        <span style="font-weight: bold">ORIENTAÇÕES PARA PREENCHIMENTO:</span>
      </p>

      <p style="margin-right: 14.1pt; text-align: justify">
        <span>O responsável pelo preenchimento da inscrição deverá:</span>
      </p>
      <ul type="disc" style="margin: 0pt; padding-left: 0pt">
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Informar corretamente os dados da Sala do Empreendedor ou da
            instituição parceira;</span
          >
        </li>
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Acessar o link de inscrição e preencher diretamente o
            formulário;</span
          >
        </li>
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Preencher corretamente todas as informações solicitadas;</span
          >
        </li>
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Responder a todas as perguntas com atenção e dentro do prazo
            estipulado;</span
          >
        </li>
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Preencher apenas um formulário. Não será aceito mais de um
            diagnóstico por sala;</span
          >
        </li>
        <li
          style="
            margin-right: 14.1pt;
            margin-left: 27.6pt;
            text-align: justify;
            line-height: 108%;
            padding-left: 8.4pt;

            font-size: 12px;
            -aw-font-family: 'Symbol';
            -aw-font-weight: normal;
            -aw-number-format: '';
          "
        >
          <span style="line-height: 108%; font-size: 12px"
            >Reservar pelo menos 30 minutos exclusivamente para o preenchimento
            do diagnóstico.
          </span>
        </li>
      </ul>
      <p style="margin-right: 14.1pt; text-align: justify">
        <span
          >O preenchimento da inscrição deve ser feito com atenção, pois, após o
          envio, não será possível substituir ou alterar as informações, mesmo
          que ainda esteja dentro do período estabelecido para a etapa de
          inscrição.</span
        >
      </p>
      <p style="margin-right: 14.1pt; text-align: justify">
        <span
          >Os dados cadastrais, bem como as informações sobre serviços,
          infraestrutura, equipe e canais de atendimento, devem ser informados
          com precisão, pois serão considerados no processo de validação das
          evidências e na composição da pontuação da instituição parceira.</span
        >
      </p>
      <p style="margin-bottom: 0pt; text-align: justify; line-height: normal">
        <span style="-aw-import: ignore">&#xa0;</span>
      </p>
      <p
        style="
          margin-bottom: 0pt;
          text-align: justify;
          line-height: normal;
          font-size: 12pt;
          background-color: #2a4fd7;
          padding: 10px;
          color: #fff;
        "
      >
        Conheça os termos da Lei nº 13.709/18 – Lei Geral de Proteção de Dados
        Pessoais, o Sebrae disponibiliza para a consulta os termos de Uso do
        Portal e Política de Privacidade.
      </p>
      <v-form ref="form">
        <p class="BodyText" style="margin-top: 10px">
          <!-- <v-checkbox v-model="payload.aceite" :rules="rules">
          <template v-slot:label>
            <span id="checkboxLabel"
              >Termo de adesão ao Selo: Estou ciente e concordo com o
              <a
                href="https://slide1-manuais.s3.amazonaws.com/public/termos-inscricao/Termo_de_Adesao_-_Selo_Sebrae_de_Refer%C3%AAncia_do_Atendimento_-_VF.2024.pdf"
                target="_blank"
                @click.stop
                >termo de adesão ao Selo Sebrae de Referência em Atendimento</a
              ></span
            >
          </template>
        </v-checkbox> -->
          <v-checkbox v-model="payload.lgpd" :rules="rules">
            <template v-slot:label>
              <span
                >TERMO LGPD: Estou ciente e concordo com o
                <a
                  href="https://slide1-manuais.s3.amazonaws.com/public/termos-inscricao/Termo_de_Autoriza%C3%A7%C3%A3o_de_Uso_de_Dados_-_Selo_Sebrae_de_Refer%C3%AAncia_do_Atendimento_-_VF_2024.pdf"
                  target="_blank"
                  @click.stop
                  >termo LGPD.</a
                ></span
              >
            </template>
          </v-checkbox>
        </p>
      </v-form>
      <p
        style="
          margin: 0 auto;
          text-align: justify;
          line-height: normal;
          font-size: 12pt;
          text-align: center;
        "
      >
        <v-btn color="primary" @click="submit"> Eu concordo</v-btn>
      </p>
      <p
        style="
          margin-top: 14pt;
          margin-bottom: 0pt;
          text-align: justify;
          line-height: normal;
          font-size: 12pt;
          text-align: center;
        "
      >
        <a
          href="http://www.sebrae.com.br/selosebraedereferencia"
          style="text-decoration: none"
          ><span class="Hyperlink"
            >www.sebrae.com.br/selosebraedereferencia</span
          ></a
        >
      </p>
      <p
        style="
          margin-top: 14pt;
          margin-bottom: 0pt;
          text-align: justify;
          line-height: normal;
          font-size: 12pt;
        "
      >
        <span style="-aw-import: ignore">&#xa0;</span>
      </p>
      <p style="line-height: 108%; font-size: 12pt">
        <span style="-aw-import: ignore">&#xa0;</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      payload: {},
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  methods: {
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async submit() {
      var isValid = await this.check();
      if (!isValid) {
        this.$notification.error("É necessário aceitar todos os termos.", {
          timer: 10,
        });
        return;
      }

      this.$emit("concordarOk");
    },
  },
};
</script>
<style lang="scss" scoped>
.termos {
  line-height: 108%;
  font-size: 12px;
  font-family: Roboto;
  .conteudo {
    margin: 0 auto;
    max-width: 800px;
    font-size: 12px;
  }
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0pt 0pt 8pt;
}
li {
  margin-top: 0pt;
  margin-bottom: 8pt;
}
h1 {
  margin-top: 18pt;
  margin-bottom: 4pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 20pt;
  font-weight: normal;
  color: #0f4761;
}
h2 {
  margin-top: 8pt;
  margin-bottom: 4pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 16pt;
  font-weight: normal;
  color: #0f4761;
}
h3 {
  margin-top: 8pt;
  margin-bottom: 4pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 14pt;
  font-weight: normal;
  color: #0f4761;
}
h4 {
  margin-top: 4pt;
  margin-bottom: 2pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  color: #0f4761;
}
h5 {
  margin-top: 4pt;
  margin-bottom: 2pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  color: #0f4761;
}
h6 {
  margin-top: 2pt;
  margin-bottom: 0pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  color: #595959;
}
.Heading7 {
  margin-top: 2pt;
  margin-bottom: 0pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  color: #595959;
  -aw-style-name: heading7;
}
.Heading8 {
  margin-bottom: 0pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  color: #272727;
  -aw-style-name: heading8;
}
.Heading9 {
  margin-bottom: 0pt;
  page-break-inside: avoid;
  page-break-after: avoid;
  line-height: 108%;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  color: #272727;
  -aw-style-name: heading9;
}
.BodyText {
  margin-bottom: 0pt;
  line-height: normal;
  widows: 0;
  orphans: 0;
  font-family: Roboto;
  font-size: 12pt;
  font-weight: bold;
  -aw-style-name: body-text;
}
.Footer {
  margin-bottom: 0pt;
  line-height: normal;
  font-size: 12px;
  -aw-style-name: footer;
}
.Header {
  margin-bottom: 0pt;
  line-height: normal;
  font-size: 12px;
  -aw-style-name: header;
}
.IntenseQuote {
  margin: 18pt 43.2pt;
  text-align: center;
  line-height: 108%;
  border-top: 0.75pt solid #0f4761;
  border-bottom: 0.75pt solid #0f4761;
  padding-top: 10pt;
  padding-bottom: 10pt;
  font-size: 12px;
  font-style: italic;
  color: #0f4761;
  -aw-border-bottom: 0.5pt single;
  -aw-border-top: 0.5pt single;
  -aw-style-name: intense-quote;
}
.ListParagraph {
  margin-left: 36pt;
  margin-bottom: 8pt;
  line-height: 108%;
  font-size: 12px;
  -aw-style-name: list-paragraph;
}
.Quote {
  margin-top: 8pt;
  margin-bottom: 8pt;
  text-align: center;
  line-height: 108%;
  font-size: 12px;
  font-style: italic;
  color: #404040;
  -aw-style-name: quote;
}
.Subtitle {
  margin-bottom: 8pt;
  line-height: 108%;
  font-size: 14pt;
  letter-spacing: 0.75pt;
  color: #595959;
  -aw-style-name: subtitle;
}
.Title {
  margin-bottom: 4pt;
  line-height: normal;
  font-size: 28pt;
  letter-spacing: -0.5pt;
  -aw-style-name: title;
}
span.CitaoCarter {
  font-style: italic;
  color: #404040;
}
span.CitaoIntensaCarter {
  font-style: italic;
  color: #0f4761;
}
span.CorpodetextoCarter {
  font-family: Roboto;
  font-size: 12pt;
  font-weight: bold;
}
span.FollowedHyperlink {
  text-decoration: underline;
  color: #96607d;
  -aw-style-name: followed-hyperlink;
}
span.Hyperlink {
  text-decoration: underline;
  color: #467886;
  -aw-style-name: hyperlink;
}
span.IntenseEmphasis {
  font-style: italic;
  color: #0f4761;
  -aw-style-name: intense-emphasis;
}
span.IntenseReference {
  font-weight: bold;
  font-variant: small-caps;
  letter-spacing: 0.25pt;
  color: #0f4761;
  -aw-style-name: intense-reference;
}
span.SubttuloCarter {
  font-size: 14pt;
  letter-spacing: 0.75pt;
  color: #595959;
}
span.Ttulo1Carter {
  font-size: 20pt;
  color: #0f4761;
}
span.Ttulo2Carter {
  font-size: 16pt;
  color: #0f4761;
}
span.Ttulo3Carter {
  font-size: 14pt;
  color: #0f4761;
}
span.Ttulo4Carter {
  font-style: italic;
  color: #0f4761;
}
span.Ttulo5Carter {
  color: #0f4761;
}
span.Ttulo6Carter {
  font-style: italic;
  color: #595959;
}
span.Ttulo7Carter {
  color: #595959;
}
span.Ttulo8Carter {
  font-style: italic;
  color: #272727;
}
span.Ttulo9Carter {
  color: #272727;
}
span.TtuloCarter {
  font-size: 28pt;
  letter-spacing: -0.5pt;
}
span.UnresolvedMention {
  color: #605e5c;
  background-color: #e1dfdd;
  -aw-style-name: unresolved-mention;
}
</style>
